import { render } from "./CreateDeck.vue?vue&type=template&id=388aa050&scoped=true"
import script from "./CreateDeck.vue?vue&type=script&lang=js"
export * from "./CreateDeck.vue?vue&type=script&lang=js"

import "./CreateDeck.vue?vue&type=style&index=0&id=388aa050&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388aa050"]])

export default __exports__